export enum CardType {
    STRENGTH = "StrengthCard",
    QUESTION = "Question",
    ACTION = "Action",
    SOCIAL_SOLUTION = "Relations",
    PHYSICAL_SOLUTION = "Physical",
    MENTAL_SOLUTION = "Mental",
    EMOTIONAL_SOLUTION = "Emotional",
    JOKER_SOLUTION = "Joker",
}